import { render, staticRenderFns } from "./SshiLayout.vue?vue&type=template&id=60d30fd5"
import script from "./SshiLayout.vue?vue&type=script&lang=js"
export * from "./SshiLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports